<template>
    <div class="charts-container">

        <div class="chart-container" v-for="(metricGroup, index) in metricGroups" v-if="chartsReady">
            <v-icon @click="expandChart(metricGroup)" class="expand-chart-button">mdi-fullscreen</v-icon>
            <highcharts :options="metricGroup.chartOptions"></highcharts>
        </div>



        <v-dialog v-model="showExpandedChart" max-width="80%" width="800px" v-if="showExpandedChart && $props.useDialog" hide-overlay persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showExpandedChart = false : null}">
            <v-card light v-if="showExpandedChart">
                <v-icon class="remove" style="float: right; right: 8px;" @click="closeExpandedChart">mdi-close</v-icon>
                <highcharts :options="expandedChartOptions" v-if="showExpandedChart"></highcharts>
            </v-card>
        </v-dialog>

        <div id="map-metric-large-chart-container" v-if="!$props.useDialog">
            <v-icon class="remove" @click="closeExpandedChart">mdi-close</v-icon>
            <highcharts :options="expandedChartOptions" v-if="showExpandedChart"></highcharts>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
export default {
    name: 'MapItemSiteThresholdMetricsChart',
    props: ['infoWindowData', 'gettingSiteThresholdMetrics', 'useDialog'],
    components: {
    },
    data: () => ({
        metricGroups: [],
        chartsReady: false,
        showExpandedChart: false,
        expandedChartOptions: null,
        chartHeight: 200,
        chartWidth: 340
    }),

    computed: {

    },

    methods: {
        prepareMetricDataForCharts: function() {
            this.metricGroups = _.groupBy(this.$props.infoWindowData.filteredSiteThresholdMetrics, m => {
                return m.metric_name;
            });

            // calculate the width and height of the charts when expanded.
            let minWidth = 340;
            let minHeight = 220;
            let areaWidth = this.$el.offsetWidth;
            let areaHeight = this.$el.offsetHeight;
            let chartWidth = areaWidth;
            let numOfCharts = Object.entries(this.metricGroups).length;
            let chartsWide = 3;
            let desiredWidth = Math.floor(areaWidth / chartsWide) - (chartsWide * 2);
            let chartsHigh = Math.ceil(numOfCharts / chartsWide);
            let desiredHeight = Math.floor(areaHeight / chartsHigh) - (chartsWide * 2);
            if(desiredWidth < minWidth || desiredHeight < minHeight) {
                desiredWidth = minWidth;
                desiredHeight = minHeight;
            }

            for(let [metricName, metricGroup] of Object.entries(this.metricGroups)) {
                let chartTitle = metricName;
                let series = [];

                let sectorGroups = _.groupBy(metricGroup, m => {
                    return m.sect_mscid;
                });

                for(let [sectorName, sectorGroup] of Object.entries(sectorGroups)) {
                    let seriesData = [];
                    for(let metric of sectorGroup) {
                        // This will convert the time to where the users browser is. (i.e. the data was recorded at 2pm Eastern), The user is viewing it in Central
                        // the time will show 1pm. We actually dont want this. We want the time to show as if the user is located in the TZ where it was recorded(no conversion)
                        //let time = ((TELSA.moment(metric.start_time).unix() - (new Date().getTimezoneOffset() * 60)) * 1000);

                        // Dont do any conversion, so we need to tell moment to not use the TZ part.
                        let time = ((TELSA.moment(metric.start_time, "YYYY-MM-DD HH:mm:ss").unix() - (new Date().getTimezoneOffset() * 60)) * 1000);

                        let value = Number((Math.round(Number(metric.metric_value) * 10000) / 10000).toFixed(4));
                        seriesData.push([time, value]);
                    }
                    series.push({
                        name: sectorName,
                        data: seriesData
                    });
                }


                let chartOptions = {
                    chart: {
                        type: 'line',
                        backgroundColor: 'transparent',
                        zoomType: 'x',
                        // height: 220,
                        // width: 330
                        height: desiredHeight,
                        width: desiredWidth
                    },
                    credits: {
                        enabled: false
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: chartTitle,
                        style: {
                            color: '#000000'
                        }
                    },
                    subtitle: {
                        text: '',
                        style: {
                            color: '#000000'
                        }
                    },

                    plotOptions: {
                        column: {
                            pointPadding: 0.2,
                            borderWidth: 0
                        },
                    },
                    legend: {
                        itemStyle: {
                            color: '#000000'
                        },
                        itemHoverStyle:{
                            color: 'gray'
                        },
                        enabled: false
                    },

                    xAxis: {
                        // Columns
                        categories: null,
                        title: {
                            //text: "Start Time"
                        },
                        labels: {
                            enabled: true,
                            // style: {
                            //     color: "#2F2F2F"
                            // }
                        },
                        type: 'datetime'
                    },

                    yAxis: {
                        title: false
                    },

                    series: series,
                };

                metricGroup.chartOptions = chartOptions;
            }

            this.chartsReady = true;
        },

        expandChart: function(chart) {
            this.expandedChartOptions = chart.chartOptions;
            this.expandedChartOptions.legend.enabled = true;
            this.showExpandedChart = true;

            if(this.$props.useDialog) {
                chart.chartOptions.chart.width = 780;
                chart.chartOptions.chart.height = 500;
            }
            else {
                chart.chartOptions.chart.width = 1180;
                chart.chartOptions.chart.height = 470;
                let appEl = document.getElementById('application-router-view-container');
                let chartEl = document.getElementById('map-metric-large-chart-container');
                appEl.append(chartEl);
                chartEl.classList.add('show');
            }
        },

        closeExpandedChart: function() {
            if(!this.$props.useDialog) {
                let chartEl = document.getElementById('map-metric-large-chart-container');
                chartEl.classList.remove('show');
            }
            this.showExpandedChart = false;
            this.expandedChartOptions = null;
        }
    },

    watch: {
        gettingSiteThresholdMetrics: {
            handler(newVal, oldVal) {
                if(newVal) {
                    this.chartsReady = false;
                }
                else {
                    this.prepareMetricDataForCharts();
                }
            }
        },

        infoWindowData: {
            handler(newVal, oldVal) {
                if(!this.gettingSiteThresholdMetrics) {
                    let el = this.$el;
                    this.prepareMetricDataForCharts();
                }
            },
            deep: true
        }
    },

    mounted() {
        if(!this.gettingSiteThresholdMetrics) {
            let el = this.$el;
            this.prepareMetricDataForCharts();
        }
    },

    destroyed() {
        let chartEl = document.getElementById('map-metric-large-chart-container');
        if(chartEl) {
            chartEl.remove();
        }
    }  
};
</script>

<style scoped>

    .charts-container {
        height: 100%;
        overflow-y: auto;
        background-color: #FFFFFF;
    }

    .chart-container {
        display: inline-block;
        position: relative;
        border: gray 1px dotted;
        margin: 2px;
    }

    .chart-container .expand-chart-button {
        color: #c42111;
        cursor: pointer;
        z-index: 2;
        position: absolute;
        top: 0px;
        left: 0px;
    }

    #map-metric-large-chart-container {
        display: none;
        position: absolute;
        z-index: 9999999;
        width: 1200px;
        max-width: 80%;
        max-height: 80vh;
        height: 470px;
        background-color: #ffffff;
        border: gray solid 1px;
        border-radius: 10px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    #map-metric-large-chart-container .remove {
        color: #000000;
        z-index: 9999999999999999999;
        position: relative;
        float: right;
    }

    #map-metric-large-chart-container.show {
        display: block;
    }

</style>
